import { createFileRoute, Navigate } from '@tanstack/react-router'

// Redirect shim: the old "Опубликованные" tab was merged into the registry
// (#262). This was the default /properties redirect target before, so stale
// bookmarks to it are especially likely.
export const Route = createFileRoute('/_app/properties/published')({
	component: () => <Navigate to="/properties/registry" replace />,
})
